import React, {useState, useEffect} from "react";
import {Container} from "react-bootstrap";
import {descargarArchivo} from "../AccionesBackend";

const ImageItem = ({image}) => (
    <div className="report-item" style={{cursor: "pointer"}}>
        <a href={image.src} target="_blank" rel="noopener noreferrer">
            <img
                alt={`Imagen mostrando ${image.title.toLowerCase()}`}
                height="200"
                width="300"
                src={image.src}
            />
        </a>
        <h3 className="text-break">{image.title}</h3>
        <button
            onClick={() => descargarArchivo(image.seccionId, image.fileName || image.title)}
            className="btn btn-success me-2"
        >
            <i className="bi bi-download me-1"></i>
            Descargar
        </button>
    </div>
);

export const VisualizadorImagenes = ({initialImages}) => {
    const [images, setImages] = useState(initialImages || []);
    const [searchTerm, setSearchTerm] = useState("");

    // Actualizar el estado 'images' cuando 'initialImages' cambie
    useEffect(() => {
        setImages(initialImages || []);
    }, [initialImages]);

    // Filtrar imágenes según el término de búsqueda
    const filteredImages = images.filter((image) =>
        image.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <section className="reportes">
            <Container>
                <div className="content">
                    <div className="filter-section">
                        <div>
                            <label htmlFor="search-filter">Buscar:</label>
                            <input
                                id="search-filter"
                                placeholder="Escribe aquí para buscar..."
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="report-list">
                        {filteredImages.map((image, index) => (
                            <ImageItem key={index} image={image}/>
                        ))}
                    </div>
                </div>
            </Container>
        </section>
    );
};
